@if (isSkillSetSummaryView && sidebar?.summaryOfSkillSet !== null) {
  <div
    class="sidebar-header"
    >
    <div class="sidebar-header-qoute" nz-col nzSpan="24">
      <img src="../../../assets/images/quote-left.svg" />
    </div>
    <div
		[class]="
			isFirefox
				? 'sidebar-header-details sidebar-header-scroll'
				: 'sidebar-header-details'
		"
      nz-col
      nzSpan="24"
      [innerHTML]="sidebar?.summaryOfSkillSet"
    ></div>
  </div>
}

<div class="sidebar-details-section" [style.height]="sidebarHeight">
  <div class="sidebar-details">
    <label class="sidebar-details-label">Personal Details</label>
    @if (isAgeView && sidebar?.birthDate !== null) {
      <div>
        <span class="sidebar-content-label">Age: </span>
        <span class="sidebar-content"
          >{{ calculateAge(sidebar?.birthDate) }} years old</span
          >
        </div>
      }
      @if (isBirthdateView && sidebar?.birthDate !== null) {
        <div>
          <span class="sidebar-content-label">Birthdate: </span>
          <span class="sidebar-content">{{
            sidebar?.birthDate | date : 'dd MMMM yyyy'
          }}</span>
        </div>
      }
      @if (isMaritalStatusView && sidebar?.maritalStatus !== null) {
        <div>
          <span class="sidebar-content-label">Marital Status: </span>
          <span class="sidebar-content"> {{ sidebar?.maritalStatus }} </span>
        </div>
      }
      @if (isLocationView && sidebar?.location?.length > 0) {
        <div>
          <span class="sidebar-content-label">Location: </span>
          <span class="sidebar-content"
            >{{ sidebar?.location[0]?.stateProvincesDes }},
            {{ sidebar?.location[0]?.countryDes }}</span
            >
          </div>
        }
      </div>
      @if (
        sidebar?.availability != null ||
        sidebar?.yearsOfExperience !== null ||
        sidebar?.yearsOfBpoExperience !== null
        ) {
        <div
          class="sidebar-details"
          >
          <label class="sidebar-details-label">Work Details</label>
          @if (isAvailabilityView && sidebar?.availability != null) {
            <div>
              <span class="sidebar-content-label">Availability: </span>
              <span class="sidebar-content">{{ sidebar?.availability }}</span>
            </div>
          }
          @if (isYearsExpView && sidebar?.yearsOfExperience !== null) {
            <div>
              <span class="sidebar-content-label">Professional Experience: </span>
              <span class="sidebar-content">
                {{ sidebar?.yearsOfExperience }} years</span
                >
              </div>
            }
            @if (isYearsBPOView && sidebar?.yearsOfBpoExperience !== null) {
              <div>
                <span class="sidebar-content-label">BPO Experience: </span>
                <span class="sidebar-content"
                  >{{ sidebar?.yearsOfBpoExperience }} years</span
                  >
                </div>
              }
            </div>
          }

          @if(sidebar?.links?.length > 0 && isLinksView){
            <div class="sidebar-details">
              <label class="sidebar-details-label">Links</label>
              <ul>
                @for (link of sidebar?.links; track $index) {
                  <li>
                    <a [href]="link.url" target="_blank" rel="noopener noreferrer"
                      >{{ link.name }}
                      <i class="fa-regular fa-arrow-up-right-from-square"></i
                      ></a>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
